import { render, staticRenderFns } from "./ScopeSettings.vue?vue&type=template&id=58d3da68&"
import script from "./ScopeSettings.vue?vue&type=script&lang=js&"
export * from "./ScopeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports